// Dashboard.jsx
import React from 'react';
import Sidebar from '../components-dashboard/DashboardSidebar';
import TopBar from '../components-dashboard/TopBar';
import OverviewSection from '../components-dashboard/OverviewSection';
import BiddingActivityChart from '../components-dashboard/BiddingActivityChart';
import AutoBidsHistoryChart from '../components-dashboard/AutoBidsHistoryChart';
import ControlPanel from '../components-dashboard/ControlPanel';


const Dashboard = () => {
 

  // Default stats data - can be replaced with actual data fetching later
  const stats = {
    totalBids: 0,
    limitAlert: {
      message: 'No alerts at this time'
    }
  };

  return (
    <div className="flex min-h-screen bg-light-blue-shade-20">
      <Sidebar />
      <div className="flex-1 ml-0 lg:ml-60">
        <TopBar userName={'Co-Ventech'} />
        <div className="p-6 lg:p-8 max-w-7xl">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-semibold text-gray-900">Overview</h1>
            <ControlPanel />
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
            {/* Left column - 60% (3 out of 5 columns) */}
            <div className="lg:col-span-3 flex flex-col gap-2.5">
              <OverviewSection stats={stats} />
              <BiddingActivityChart />
            </div>
            
            {/* Right column - 40% (2 out of 5 columns) */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              <AutoBidsHistoryChart />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
